/*
    Autohandler for updating a button file.
 */

var $ = require('./../sw-jquery');
var sw = require('js/lib/sw');
var scaleOptionsTemplate = require('rrTags/model/templates/tpl.model-update-scale-options.mustache');

$(function () {

    $('body').on('change', '[data-sw-model-update-input]' , function (e) {
        var modelFile = e.target.files[0];

        sw.notifications.content(scaleOptionsTemplate.render(), {});

        $('[data-sw-model-upload-scale-option]').on('click', function (e) {
            var $form = $('[data-sw-model-update-form]');
            var formData = new window.FormData();
            formData.append('file', modelFile);
            formData.append('scale', $(e.target).data('swModelUploadScaleOption'));

            $.ajax({
                url: $form.attr('action'),
                type: $form.attr('method'),
                data: formData,
                processData: false,
                contentType: false,
                dataType: 'json',
                success: function(response){
                    sw.notifications.success(response.message);
                    window.location.reload();
                }
            });

        });

    });


});
